import './App.css';
import { Routes, Route, HashRouter } from 'react-router-dom';
import { DictionaryComponent } from '../src/screens/dictionary';
import { ThesaurusComponent } from '../src/screens/thesaurus';
import React from 'react';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<DictionaryComponent />} />
        <Route path="/thesaurus" element={<ThesaurusComponent />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
